import script from "./ProjectDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDescription.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDescription.vue?vue&type=style&index=0&id=31861698&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31861698"]])

export default __exports__